/* tslint:disable */
/* eslint-disable */
/**
 * FraudFighter API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SearchAgentSource {
    ByManualSearch = 'ByManualSearch',
    ByDmrLookup = 'ByDMRLookup',
    ByAdvancedSearch = 'ByAdvancedSearch'
}

export function SearchAgentSourceFromJSON(json: any): SearchAgentSource {
    return SearchAgentSourceFromJSONTyped(json, false);
}

export function SearchAgentSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchAgentSource {
    return json as SearchAgentSource;
}

export function SearchAgentSourceToJSON(value?: SearchAgentSource | null): any {
    return value as any;
}

